module.exports = __webpack_public_path__ + "static/media/tech-icon-inside.6a851b77.svg";